
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 0a8 8 0 100 16A8 8 0 008 0zm3.825 5.524c.255.265.339.866.339.866s.085.705.085 1.411v.662c0 .705-.085 1.411-.085 1.411s-.084.6-.339.865c-.292.313-.616.346-.799.364l-.055.006c-1.192.088-2.983.091-2.983.091s-2.215-.02-2.897-.088c-.032-.006-.071-.01-.115-.016-.216-.027-.555-.068-.824-.357-.256-.264-.339-.865-.339-.865s-.085-.706-.085-1.411V7.8c0-.706.085-1.411.085-1.411s.083-.601.339-.866c.292-.313.616-.345.8-.363a2.61 2.61 0 00.054-.006c1.192-.088 2.98-.088 2.98-.088h.004s1.789 0 2.981.088l.055.006c.183.018.507.05.799.363zm-4.717 1.29v2.45l2.303-1.22-2.303-1.23z","fill":"currentColor"}})])
          )
        }
      }
    